
const RunningSvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 93C31 93 40.1 92 44.5 92C50 92 56.5 96 66.5 96M66.5 96C113.5 89 115 69.5002 117 67.4969C119 65.4935 119.833 66.3302 120.5 67.4969C126.01 83.3978 101 93 96 93.9967C91 94.9935 75.6667 96 66.5 96Z"
        stroke="#0085FF"
      />
      <path
        d="M113 74.5C59 91.5 32 70.5 25.0005 68.9988C18.001 67.4976 11.5 71.9997 10.0005 74.4988C8.50095 76.9978 8.60923 78.6135 9.00047 81.9988C9.2174 83.8757 11 88.5 12.5 90C14 91.5 17.5 92.5 21.5 93"
        stroke="#0085FF"
      />
      <path
        d="M45 48.5C55.3333 53.5 77.3 64 80.5 64C83.7 64 86.1667 61.3333 87 60"
        stroke="#0085FF"
      />
      <path
        d="M18 54.5C20.4 54.9 49 61.5 55.5 65C58.7857 66.7692 63 72.5 63 80.5"
        stroke="#0085FF"
      />
      <path d="M31 71C35 65 46.5 59.5 58.5 55" stroke="#0085FF" />
      <path
        d="M17 54C26.0457 57.9218 40 64.5 44 66.5C48 68.5 51 73 51.5 78.5"
        stroke="#0085FF"
      />
      <path
        d="M44 76.5C49.0396 67.7604 56.4092 62.9957 65 58"
        stroke="#0085FF"
      />
      <path
        d="M14.5 70.5C15.8945 60.2213 17.025 54.4473 19.5 44C20.6667 43 23.9 41.6 27.5 44C31.1 46.4 36.6667 50 39 51.5C39 51.5 52 44 58 44C64 44 84.5 59.5 93.5 62.5C102.5 65.5 115.5 63.5 117 64C118.2 64.4 119.5 65.8333 120 66.5"
        stroke="#0085FF"
      />
      <path
        d="M54 53L63.5 46.5L64 57L73 51.5L75.5 62L81.5 56.5"
        stroke="#0085FF"
      />
      <path d="M39 51.5C33.8333 54.6667 22.7 57.6 19.5 44" stroke="#0085FF" />
      <path d="M54.5 53L71.5 52L64.5 57H81.5L76 62" stroke="#0085FF" />
    </svg>
  );
};

export default RunningSvg;
